import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export const habitationsApi = {
  getVillages: (rdBlockId?: number) =>
    api.get<ApiResponse<{id: number, name: string, rd_block_id: number}[]>>(
      rdBlockId ? `/locations/villages/${rdBlockId}` : '/locations/villages'
    ),

  getAllVillages: () =>
    api.get<ApiResponse<{id: number, name: string, rd_block_id: number, is_active: boolean}[]>>('/locations/villages/all'),

  getActiveVillages: () =>
    api.get<ApiResponse<{id: number, name: string, rd_block_id: number, is_active: boolean}[]>>('/locations/villages/active'),

  createHabitation: (data: { name: string, rd_block_id: number, is_active?: boolean }) =>
    api.post<ApiResponse<any>>('/locations/habitations', data),

  updateHabitation: (id: number, data: { name: string, rd_block_id: number, is_active?: boolean }) =>
    api.put<ApiResponse<any>>(`/locations/habitations/${id}`, data),

  deleteHabitation: (id: number) =>
    api.delete<ApiResponse<any>>(`/locations/habitations/${id}`),

  hardDeleteHabitation: (id: number) =>
    api.delete<ApiResponse<any>>(`/locations/habitations/${id}/permanent`),
}

